export default class MultiSelect {
    constructor(config = {}) {
        this.defaultConfig = {
            search: true,
            height: '15rem',
            placeholder: 'select',
            txtSelected: 'selected',
            txtAll: 'All',
            txtRemove: 'Remove',
            txtSearch: 'search',
        };
        this.defaultConfig = Object.assign(Object.assign({}, this.defaultConfig), config);
        this.elements = document.querySelectorAll("select[multiple]");
        if (this.elements != null) {
            this.init();
        }
    }
    init() {
        this.elements.forEach((el, k) => {
            var _a, _b, _c;
            let configAttributes = el.getAttribute("config");
            let elementConfig = configAttributes ? JSON.parse(configAttributes) : {};
            let config = Object.assign(this.defaultConfig, elementConfig);
            var div = this.newElement('div', { class: 'multiselect-dropdown', style: {} });
            el.style.display = 'none';
            el.parentNode.insertBefore(div, el.nextSibling);
            var placeholder = this.newElement('div', { class: 'placeholder' });
            var listWrap = this.newElement('div', { class: 'multiselect-dropdown-list-wrapper' });
            var list = this.newElement('div', { class: 'multiselect-dropdown-list', style: { height: config.height } });
            var search = this.newElement('input', { class: ['multiselect-dropdown-search'].concat([(_b = (_a = config.searchInput) === null || _a === void 0 ? void 0 : _a.class) !== null && _b !== void 0 ? _b : 'form-control']), style: { width: '100%', display: ((_c = el.attributes['multiselect-search']) === null || _c === void 0 ? void 0 : _c.value) === 'true' ? 'block' : 'none' }, placeholder: config.txtSearch });
            listWrap.appendChild(search);
            div.appendChild(listWrap);
            div.appendChild(placeholder);
            listWrap.appendChild(list);
            var placeholderText = this.newElement('span', {});
            var placeholderIcon = this.newElement('i', {});
            placeholder.appendChild(placeholderText);
            placeholder.appendChild(placeholderIcon);
            el["loadOptions"] = () => {
                var _a;
                list.innerHTML = '';
                if (((_a = el.attributes['multiselect-select-all']) === null || _a === void 0 ? void 0 : _a.value) == 'true') {
                    var op = this.newElement('div', { class: 'multiselect-dropdown-all-selector' });
                    var ic = this.newElement('input', { type: 'checkbox' });
                    op.appendChild(ic);
                    op.appendChild(this.newElement('label', { text: config.txtAll }));
                    op.addEventListener('click', () => {
                        op.classList.toggle('checked');
                        op.querySelector("input").checked = !op.querySelector("input").checked;
                        var ch = op.querySelector("input").checked;
                        list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector)")
                            .forEach(i => { if (i.style.display !== 'none') {
                            i.querySelector("input").checked = ch;
                            i["optEl"].selected = ch;
                        } });
                        el.dispatchEvent(new Event('change'));
                    });
                    ic.addEventListener('click', (ev) => {
                        ic.checked = !ic.checked;
                    });
                    el.addEventListener('change', (ev) => {
                        let itms = Array.from(list.querySelectorAll(":scope > div:not(.multiselect-dropdown-all-selector)"))
                            .filter(e => e.style.display !== 'none');
                        let existsNotSelected = itms.find(i => !i.querySelector("input").checked);
                        if (ic.checked && existsNotSelected)
                            ic.checked = false;
                        else if (ic.checked == false && existsNotSelected === undefined)
                            ic.checked = true;
                    });
                    list.appendChild(op);
                }
                Array.from(el.children).map(oEl => {
                    if (oEl.children && oEl.children.length > 0) {
                        list.appendChild(this.createOptionGroup(oEl));
                        Array.from(oEl.children).map(opt => {
                            list.appendChild(this.createOption(opt));
                        });
                    }
                    else {
                        list.appendChild(this.createOption(oEl));
                    }
                });
                div["listEl"] = listWrap;
                div["refresh"] = () => {
                    var _a, _b;
                    let placeholder = (_b = (_a = el.attributes['placeholder']) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : config.placeholder;
                    if (el.selectedOptions.length > 0)
                        placeholder += " (" + el.selectedOptions.length + ")";
                    placeholderText.innerText = placeholder;
                };
                div["refresh"]();
            };
            el["loadOptions"]();
            search.addEventListener('input', () => {
                list.querySelectorAll(":scope div:not(.multiselect-dropdown-all-selector)").forEach(d => {
                    var txt = d.querySelector("label").innerText.toUpperCase();
                    d.style.display = txt.includes(search.value.toUpperCase()) ? 'block' : 'none';
                });
            });
            div.addEventListener('click', () => {
                div["listEl"].style.display = 'block';
                if (!div.hasClass("open")) {
                    div.addClass("open");
                    search.focus();
                    search.select();
                }
                else {
                    div.addClass("false");
                }
            });
            document.addEventListener('click', function (event) {
                const target = event.target;
                if (!div.contains(target)) {
                    listWrap.style.display = 'none';
                    div.removeClass("open");
                    div["refresh"]();
                }
            });
        });
    }
    createOptionGroup(el) {
        var group = el;
        var isEmpty = group.label == "";
        var container = this.newElement('div', { class: (isEmpty ? "empty-group" : "select-group") });
        if (!isEmpty)
            container.appendChild(this.newElement('h1', { text: group.label }));
        return container;
    }
    createOption(el) {
        var option = el;
        var op = this.newElement('div', { class: option.selected ? 'checked' : '', optEl: option });
        var ic = this.newElement('input', { type: 'checkbox', checked: option.selected });
        op.appendChild(ic);
        op.appendChild(this.newElement('label', { text: option.text }));
        op.addEventListener('click', () => {
            op.classList.toggle('checked');
            op.querySelector("input").checked = !op.querySelector("input").checked;
            op["optEl"].selected = !!!op["optEl"].selected;
            console.log(el.closest("select"));
            el.closest("select").dispatchEvent(new Event('change'));
        });
        ic.addEventListener('click', (ev) => {
            ic.checked = !ic.checked;
        });
        option["listitemEl"] = op;
        return op;
    }
    newElement(tag, attrs) {
        var e = document.createElement(tag);
        if (attrs !== undefined)
            Object.keys(attrs).forEach(k => {
                if (k === 'class') {
                    Array.isArray(attrs[k]) ? attrs[k].forEach(o => o !== '' ? e.classList.add(o) : 0) : (attrs[k] !== '' ? e.classList.add(attrs[k]) : 0);
                }
                else if (k === 'style') {
                    Object.keys(attrs[k]).forEach(ks => {
                        e.style[ks] = attrs[k][ks];
                    });
                }
                else if (k === 'text') {
                    attrs[k] === '' ? e.innerHTML = '&nbsp;' : e.innerText = attrs[k];
                }
                else
                    e[k] = attrs[k];
            });
        return e;
    }
}
